import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat102Store from "../../../../../stores/khattabat-stores/102-stores";
import getKhattabat102MessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import { E_KHATTABAT_CONVERSATION_TYPE } from "../../../../../Types";
import KhattabatOneOTwoQuality from "./conversation-states/KhattabatOneOTwoQuality";

const KhattabatConversationHeader = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;

  const { conversationType, getConversationTitle } =
    getKhattabatSharedMessagingStore(conversationID);
  const { matchReceiverID, matchReceiverName, isSilentBanned } =
    getKhattabat102MessagingStore(conversationID);
  const khattabat102Store = getKhattabat102Store(conversationID);
  const { conversationStatuskey, conversationExitDate } =
    khattabat102Store.getConversationHeaderStatusValues();
  const {
    khattabaMessagesCounter,
    clientMessagesCounter,
    matchMessagesCounter
  } = khattabat102Store.getMessagesCounters();

  const { titleKey, titleColor } = getConversationTitle();
  const isOneOTwoConversation =
    conversationType.get() === E_KHATTABAT_CONVERSATION_TYPE.ONE_O_TWO;

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      columnGap={3}
      rowGap={1}
      sx={{ width: "100%", pr: 1 }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <Typography fontWeight={fontWeights.semibold} color={titleColor}>
          {i18n.get(titleKey)}
          {isOneOTwoConversation ? (
            <>
              {" "}
              <Link
                href={`/users/advanced?id=${matchReceiverID.get()}`}
                target="_blank"
                color="inherit"
                underline="hover"
                onClick={(event) => event.stopPropagation()}
              >
                {matchReceiverName.get()}
              </Link>
            </>
          ) : null}
        </Typography>
        {isOneOTwoConversation ? (
          <>
            {isSilentBanned.get() === 1 ? (
              <Chip
                size="small"
                color="error"
                label={i18n.get("SILENT_BAN_ABBREVIATION")}
              />
            ) : null}
            <Chip
              size="small"
              variant="outlined"
              color={khattabat102Store.getConversationStatusColor()}
              label={i18n.get(conversationStatuskey)}
            />
            {khattabat102Store.getShouldShowExitDate() ? (
              <Typography variant="caption" color="text.secondary">
                {`${conversationExitDate}`}
              </Typography>
            ) : null}
          </>
        ) : null}
      </Stack>
      {isOneOTwoConversation ? (
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ ml: "auto" }}
        >
          <Chip
            size="small"
            variant="outlined"
            label={[
              i18n.getWithExtraData(
                i18n.get("KHATTABA_102_COUNTER"),
                `${khattabaMessagesCounter}`
              ),
              i18n.getWithExtraData(
                i18n.get("CLIENT_102_COUNTER"),
                `${clientMessagesCounter}`
              ),
              i18n.getWithExtraData(
                i18n.get("MATCH_102_COUNTER"),
                `${matchMessagesCounter}`
              )
            ].join(" · ")}
          />
          <KhattabatOneOTwoQuality oneOTwoConversationId={conversationID} />
        </Stack>
      ) : null}
    </Stack>
  );
});

export default KhattabatConversationHeader;
